import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { catchError, map, Observable, of } from 'rxjs';
import { ListSecretInfo, ListSecretsResponse, SecretInfo } from '../../api/models';
import {
  listAllSecrets as listAllSecretsFn,
  ListAllSecrets$Params,
} from '../../api/fn/secrets/list-all-secrets';
import {
  createSecret as createSecretFn,
  CreateSecret$Params,
} from '../../api/fn/secrets/create-secret';
import {
  deleteSecret as deleteSecretFn,
  DeleteSecret$Params,
} from '../../api/fn/secrets/delete-secret';

@Injectable({ providedIn: 'root' })
export class SecretService {
  constructor(private apiService: ApiService) {}

  getSecretsById(
    params: ListAllSecrets$Params
  ): Observable<{ [key: string]: ListSecretInfo } | undefined> {
    return this.apiService
      .invoke(listAllSecretsFn, params)
      .pipe(map((data) => data.secrets));
  }

  createSecret(params: CreateSecret$Params): Observable<boolean> {
    return this.apiService.invoke(createSecretFn, params).pipe(
      map(() => true),
      catchError((error) => of(false))
    );
  }

  deleteSecret(params: DeleteSecret$Params): Observable<boolean> {
    return this.apiService.invoke(deleteSecretFn, params).pipe(
      map(() => true),
      catchError((error) => of(false))
    );
  }

  listAllSecrets(params: ListAllSecrets$Params): Observable<SecretInfo[]> {
    return this.apiService.invoke(listAllSecretsFn, params).pipe(
      map((response) => {
        if (!response?.secrets) {
          return [];
        }
        return Object.values(response.secrets).flat();
      })
    );
  }
}
